import { render, staticRenderFns } from "./add-personal-user-account.vue?vue&type=template&id=0942644c&scoped=true"
import script from "./add-personal-user-account.vue?vue&type=script&lang=js"
export * from "./add-personal-user-account.vue?vue&type=script&lang=js"
import style0 from "./add-personal-user-account.vue?vue&type=style&index=0&id=0942644c&prod&lang=css&scoped=true"
import style1 from "./add-personal-user-account.vue?vue&type=style&index=1&id=0942644c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942644c",
  null
  
)

export default component.exports